import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CategoryService } from '../../services/category-service';

@Component({
    selector: 'app-category',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class CategoryComponent implements OnInit {
  public loading: boolean = false;
  public category: any;
  public sortAZChecked = false;
  public sortZAChecked = false;
  public sortRecentChecked = false;
  private defaultProducts = [];
  public bannerImageUrl: string;

  constructor(
    protected categoryService: CategoryService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.loading = true;

    const categorySlug = this.route.snapshot.paramMap.get('slug');

    this.categoryService.loadCategoryProducts(categorySlug).then((data) => {
      if (!data) {
        this.router.navigate(['/']);
        return;
      }

      this.category = data;
      this.defaultProducts = [...data.products];
      this.bannerImageUrl = this.getImageUrl(data);
      this.loading = false;
    });
  }

  public getImageUrl(category: any): string {
    if (!category?.banner_image?.data) return '';
    const byteArray = category.banner_image.data as number[];
    const chunkSize = 8192;
    let binary = '';
    for (let i = 0; i < byteArray.length; i += chunkSize) {
      binary += String.fromCharCode.apply(null, byteArray.slice(i, i + chunkSize));
    }
    const base64String = btoa(binary);
    return `data:image/jpeg;base64,${base64String}`;
  }

  public onSortAZChange(checked: boolean) {
    this.sortAZChecked = checked;
    this.sortZAChecked = false;
    this.sortRecentChecked = false;
    if (checked) {
      this.category.products.sort((a, b) =>
        a.title.trim().localeCompare(b.title.trim())
      );
    } else {
      this.resetProducts();
    }
  }

  public onSortZAChange(checked: boolean) {
    this.sortZAChecked = checked;
    this.sortAZChecked = false;
    this.sortRecentChecked = false;
    if (checked) {
      this.category.products.sort((a, b) =>
        b.title.trim().localeCompare(a.title.trim())
      );
    } else {
      this.resetProducts();
    }
  }

  public onSortRecentChange(checked: boolean) {
    this.sortRecentChecked = checked;
    this.sortAZChecked = false;
    this.sortZAChecked = false;
    if (checked) {
      this.category.products.sort(
        (a, b) => Date.parse(b.created) - Date.parse(a.created)
      );
    } else {
      this.resetProducts();
    }
  }

  private resetProducts() {
    this.category.products = [...this.defaultProducts];
  }
}
